// ─────────────────────────────────────────────────────────────
// SITE CONTENT — edit this file to update text, media, events,
// releases, videos, resources, and links. No code changes needed.
// ─────────────────────────────────────────────────────────────

// Hero video: swap to "/assets/hero.mp4" for the effects cut.
export const HERO_VIDEO = "/assets/hero-clean.mp4";
export const HERO_POSTER = "/assets/hero-poster.jpg";

export const SOCIALS = {
  spotify: "https://open.spotify.com/artist/6KxvvA6wNx3Nf4tdF6FhQb",
  apple: "https://music.apple.com/us/artist/david-rosenblum/1742107200",
  youtube: "https://www.youtube.com/@DavidRosenblumMusic",
  instagram: "https://www.instagram.com/davidrosenblum/",
  facebook: "https://facebook.com/davidalanrosenblum/",
};

export const SPOTIFY_ARTIST_EMBED =
  "https://open.spotify.com/embed/artist/6KxvvA6wNx3Nf4tdF6FhQb?utm_source=generator";

export const CONTACT_EMAILS = [
  "Admin@changethestory.today",
  "davidalanmusic@gmail.com",
];

export const ABOUT_LEAD =
  "David Rosenblum is a worship pastor, worship leader, songwriter, and Assemblies of God U.S. Missionary who has spent nearly two decades serving the local church and helping people encounter the presence of God.";

export const ABOUT_SHORT = [
  "David calls Griffin First Assembly in Griffin, Georgia, home. Whether serving there or wherever ministry takes him, his heart is to develop worship teams, invest in emerging leaders, and help create environments where excellence serves a genuine encounter with the presence of God.",
  "David believes the goal of leadership isn’t to hold onto the microphone, but to use whatever God has entrusted to you to prepare someone else to carry it. Whether leading worship, mentoring musicians, serving young men through Teen Challenge, or ministering across the United States and around the world, his heart is to see people, call out what God has placed inside them, and point them toward Jesus.",
];

// Full story — rendered when "Read David's full story" is opened.
// Block types: p (paragraph), quote (pull quote), lines (stacked short lines).
export const ABOUT_FULL = [
  { type: "p", text: "For nearly two decades, David Rosenblum has served the local church as a worship pastor, worship leader, musician, songwriter, and ministry leader with a heart to create environments where people do more than sing songs. He wants people to genuinely encounter the presence of God." },
  { type: "p", text: "David currently serves as Worship Experience Pastor at Griffin First Assembly in Griffin, Georgia, where he leads across generations and musical styles, develops worship teams, musicians, vocalists, choirs, and emerging leaders, and helps shape worship experiences rooted in spiritual authenticity and excellence." },
  { type: "p", text: "But somewhere along the journey, David learned that worship leadership could never simply be about becoming better at standing on a platform." },
  { type: "p", text: "Years ago, while serving in West Virginia, a life coach met with him one-on-one and gave him a sobering piece of advice:" },
  { type: "quote", text: "One of these days somebody better than you, more gifted than you, more talented than you, and probably even cuter than you is going to walk into the scene. And eventually, the greatest thing you’ll have to offer is your experience." },
  { type: "p", text: "David never forgot it." },
  { type: "p", text: "What initially sounded like a warning became an invitation." },
  { type: "p", text: "Okay, Lord. Then I’ll choose people over platforms." },
  { type: "p", text: "That decision has become one of the defining convictions of his ministry." },
  { type: "p", text: "The goal is not to hold onto the microphone. It is to use whatever God has entrusted to you to help prepare someone else to carry it." },
  { type: "p", text: "For David, that means celebrating when someone you have poured into becomes better than you. It means giving away opportunities instead of guarding them. It means making room for younger leaders, calling out gifts in people before they always see those gifts in themselves, and believing that ministry is bigger than any one season, position, or person." },
  { type: "p", text: "His good friend, the late Pastor Jeff Leake, often said:" },
  { type: "quote", text: "Success in ministry is not measured by what you do, but by what you set in motion.", attribution: "Pastor Jeff Leake" },
  { type: "p", text: "Those words have stayed with David." },
  { type: "p", text: "Because eventually, the microphone gets handed to somebody else. And he wants to spend his life helping make sure they are ready when it does." },
  { type: "p", text: "That philosophy shapes the way David leads worship teams, develops musicians and vocalists, mentors young leaders, and approaches ministry beyond the walls of the local church." },
  { type: "p", text: "Over the years, David has had the opportunity to serve churches, youth camps, conferences, ministry retreats, district events, and large gatherings across the United States. His ministry has also carried him internationally, with opportunities to serve in places including Tanzania, El Salvador, and Sweden." },
  { type: "p", text: "But for David, worship ministry has never been primarily about a stage." },
  { type: "p", text: "Alongside his ministry in the local church, David serves as an Assemblies of God U.S. Missionary through Chaplaincy with Teen Challenge, ministering at Heartland Boys Academy – Georgia. There, ministry often looks less like a spotlight and more like conversations, prayer, discipleship, mentoring, worship, pastoral care, and walking alongside young men as they discover that their past does not have to determine their future." },
  { type: "p", text: "He is passionate about helping the next generation recognize their God-given identity, develop their gifts, find freedom in Christ, and become connected to the life of the local church." },
  { type: "p", text: "For David, those worlds are not separate." },
  { type: "p", text: "Whether standing behind a microphone in a sanctuary or sitting across from a young man who needs someone to believe in him, the calling is remarkably similar:" },
  { type: "lines", items: ["See people.", "Call out what God has placed inside them.", "Make room for them to grow.", "And point them toward Jesus."] },
  { type: "p", text: "That same heartbeat shapes the way David approaches worship." },
  { type: "p", text: "He believes worship should move beyond performance and toward presence. Beyond creating moments and toward forming people. Beyond building platforms and toward raising leaders." },
  { type: "p", text: "His approach to leading worship often follows the ancient picture of the tabernacle: beginning with thanksgiving and praise, moving through testimony, faith, surrender, and response, and ultimately arriving at the simple, vertical worship of Jesus for who He is." },
  { type: "p", text: "Because the destination was never the perfect set. It was never the perfect transition. It was never the platform." },
  { type: "p", text: "After nearly twenty years of ministry, David’s calling continues to grow, but the center of it has become increasingly simple:" },
  { type: "lines", items: ["Honor Jesus.", "Steward His presence.", "Choose people over platforms.", "Raise the next generation.", "And leave every place with more leaders than were there before."] },
];

export const INVITE_INTRO =
  "Whether you’re looking for worship leadership, speaking, a team workshop, leadership development, or a combination of these, tell us a little about your church or event and what you have in mind.";

// ── Upcoming worship dates ────────────────────────────────────
// registerUrl is optional — the REGISTER button only appears
// when a link exists. Add new dates here as they're confirmed.
export const EVENTS = [
  { date: "AUG 09", year: "2026", name: "Greater Church", location: "Acworth, Georgia", details: "", registerUrl: "" },
  { date: "AUG 09", year: "2026", name: "SOS Church", location: "Buford, Georgia", details: "", registerUrl: "" },
  { date: "AUG 16", year: "2026", name: "SOS Church", location: "Buford, Georgia", details: "", registerUrl: "" },
  { date: "AUG 26", year: "2026", name: "Vincent Revival Center", location: "Vincent, Alabama", details: "", registerUrl: "" },
  { date: "SEP 06", year: "2026", name: "Highpoint Church", location: "Denver, Colorado", details: "", registerUrl: "" },
  { date: "SEP 20–28", year: "2026", name: "SOS Church", location: "Stockholm, Sweden", details: "", registerUrl: "" },
  { date: "OCT 08–11", year: "2026", name: "Cross Point Church", location: "College Station, Texas", details: "", registerUrl: "" },
  { date: "OCT 17", year: "2026", name: "Georgia Young Adults Conference", location: "Columbus, Georgia", details: "", registerUrl: "" },
  { date: "OCT 18–21", year: "2026", name: "Tennessee Ministers Retreat", location: "Gatlinburg, Tennessee", details: "", registerUrl: "" },
  { date: "NOV 05–08", year: "2026", name: "Michigan Youth Convention", location: "Brighton, Michigan", details: "", registerUrl: "" },
  { date: "NOV 12–13", year: "2026", name: "Alabama Youth Leaders Retreat", location: "Gatlinburg, Tennessee", details: "", registerUrl: "" },
];

// ── Music releases ────────────────────────────────────────────
// To add a release: copy a block, fill title/type/artwork and any
// platform URLs. Platforms left out simply don't appear.
export const RELEASES = [
  {
    title: "Worship Set, Vol. 1",
    type: "EP",
    artwork: "/assets/release-worship-set-vol-1.webp",
    links: {
      spotify: "https://open.spotify.com/album/2xs4hgVBqGqTziekSKD8Uc",
      apple: "https://music.apple.com/us/album/worship-set-vol-1-ep/1742322046",
      amazon: "https://music.amazon.com/albums/B0D28YJB4X",
      pandora: "https://www.pandora.com/artist/david-rosenblum/worship-set-vol-1/ALZbhJV2c2Ktb79",
      youtube: "https://www.youtube.com/@DavidRosenblumMusic/releases",
    },
  },
  {
    title: "Breathe (Live)",
    type: "Single",
    artwork: "/assets/release-breathe-live.webp",
    links: {
      spotify: "https://open.spotify.com/album/7Lv0Qgj9yF9zOG8EubKPhi",
      apple: "https://music.apple.com/us/album/breathe-live-single/1754097258",
      amazon: "https://music.amazon.in/albums/B0D83M593F",
      pandora: "https://www.pandora.com/artist/david-rosenblum/breathe-live/AL9cXtwfdqgzP69",
      youtube: "https://www.youtube.com/@DavidRosenblumMusic/releases",
    },
  },
  {
    title: "Worship Set, Vol. 2",
    type: "Album",
    artwork: "/assets/release-worship-set-vol-2.webp",
    links: {
      spotify: "https://open.spotify.com/album/1TF1eACVesXbTgewbOFV7E",
      apple: "https://music.apple.com/us/album/worship-set-vol-2/1781527651",
      amazon: "https://music.amazon.com/albums/B0DNXS6ZZ1",
      pandora: "https://www.pandora.com/artist/david-rosenblum/worship-set-vol-2/ALKZr3vfqq7XgbJ",
      youtube: "https://www.youtube.com/@DavidRosenblumMusic/releases",
    },
  },
  {
    title: "No Other Gospel (Live at Church)",
    type: "Single",
    artwork: "/assets/release-no-other-gospel.webp",
    links: {
      spotify: "https://open.spotify.com/album/4jJNfLhzbUSKzlDCcQavOA",
      apple: "https://music.apple.com/us/album/no-other-gospel-live-at-church-single/1808149165",
      amazon: "https://music.amazon.com/albums/B0F4N356YX",
      pandora: "https://www.pandora.com/artist/david-rosenblum/no-other-gospel-live-at-church/ALJVktJXzcV3wXw",
      youtube: "https://www.youtube.com/@DavidRosenblumMusic/releases",
    },
  },
  {
    title: "Worship Set, Vol. 3 (Live)",
    type: "EP",
    artwork: "/assets/release-worship-set-vol-3.webp",
    links: {
      spotify: "https://open.spotify.com/album/6YYF9aV8UUPBmcl4sXSrda",
      apple: "https://music.apple.com/us/album/worship-set-vol-3-live-ep/1886243534",
      amazon: "https://music.amazon.com/albums/B0GT1X7672",
      pandora: "https://www.pandora.com/artist/david-rosenblum/worship-set-vol-3-live/ALzmjbd5vq7XcZw",
      youtube: "https://www.youtube.com/@DavidRosenblumMusic/releases",
    },
  },
];

// ── Videos ────────────────────────────────────────────────────
// First video is featured large; the rest fill the grid.
// Add more with a YouTube embed URL: https://www.youtube.com/embed/VIDEO_ID
export const VIDEOS = [
  {
    title: "Holy Forever",
    embedUrl: "https://www.youtube.com/embed/LkpX2962Rbc",
    image: "/assets/IMG_1333.webp",
  },
  {
    title: "I Sing Praises + Spontaneous",
    embedUrl: "https://www.youtube.com/embed/x4j4ISXGUmU",
    image: "/assets/stage-bw-screen.webp",
  },
  {
    title: "Worthy of It All + Worthy + Agnus Dei + What a Beautiful Name",
    embedUrl: "https://www.youtube.com/embed/ebZJOagrYHo",
    image: "/assets/worship-stage.jpg",
  },
  {
    title: "Surrounded (Fight My Battles) + Spontaneous",
    embedUrl: "https://www.youtube.com/embed/LqgAIw4nUis",
    image: "/assets/stage-red.webp",
  },
  {
    title: "Agnus Dei",
    embedUrl: "https://www.youtube.com/embed/dDyb1PJf7tU",
    image: "/assets/IMG_4214.webp",
  },
];

// ── Resources & Coaching ──────────────────────────────────────
// Hero: set a video path (e.g. "/assets/resources-hero.mp4") and it
// will automatically replace the fallback photo.
export const RESOURCES_HERO_VIDEO = "";
export const RESOURCES_HERO_IMAGE = "/assets/APC02467.webp";

export const TABERNACLE_IMAGE = "/assets/IMG_1333.webp";

// Upload final workbook artwork (e.g. "/assets/6-habits-cover.jpg")
// and it replaces the built-in cover placeholder.
export const HABITS_COVER_ARTWORK = "/assets/6-habits-cover.jpeg";

export const COACHING_IMAGE = "/assets/IMG_4214.webp";
export const MANIFESTO_IMAGE = "/assets/worship-lights.jpg";

// ── Testimonials ──────────────────────────────────────────────
// One object per person. An entry only appears on the site when
// permission is true AND name, photo, and quote are all present.
// Fields:
//   name, photo, title, quote        — required to display
//   city, state                      — city optional; state-only is fine
//   organization                     — optional, shown as "Title | Organization"
//   category                         — optional label (Pastor, Worship Leader, …)
//   pullQuote                        — optional short sentence
//   featured                         — true = large editorial split slot
//   permission                       — must be true to display
// Example:
// { name: "Jonathan Smith", photo: "/assets/testimonial-1.jpg",
//   title: "Lead Pastor", city: "Nashville", state: "Tennessee",
//   quote: "…", pullQuote: "…", category: "Pastor",
//   featured: true, permission: true }
export const TESTIMONIALS = [
  {
    name: "Micah Mac", photo: "/assets/testimonial-micah.jpeg", title: "Evangelist", organization: "",
    city: "", state: "", category: "", pullQuote: "",
    quote: "On stage, David is a powerhouse vocalist and worship leader. Off stage, he looks to build others and the worship team. He will be a blessing to your church or State in any context you have him for! I highly recommend teaming up with David for your ministry!",
    featured: false, permission: true,
  },
  {
    name: "Spencer Speed", photo: "/assets/testimonial-spencer.jpeg", photoPosition: "25% center", title: "District Youth Director", organization: "North Texas AG",
    city: "", state: "", category: "", pullQuote: "",
    quote: "We love having David and his team with us. He shows true humility and authenticity in his leading on and off the stage.",
    featured: false, permission: true,
  },
  {
    name: "Peter Reeves", photo: "/assets/testimonial-peter.jpeg", title: "Evangelist", organization: "",
    city: "", state: "", category: "", pullQuote: "",
    quote: "David Rosenblum consistently creates divine heavenly moments for people to encounter God through worship. His passion, anointing, and talent captivate every room he leads in. I highly recommend him for any event you’re having.",
    featured: false, permission: true,
  },
  {
    name: "David Santistevan", photo: "/assets/testimonial-santistevan.jpeg", title: "", organization: "Beyond Sunday Podcast & Blog",
    city: "", state: "", category: "", pullQuote: "",
    quote: "Not only is his voice second to none, he leads with a humility and sensitivity to the Holy Spirit that is rare these days. He helps worshipers find their voice. He draws attention to Jesus. He fosters an atmosphere of corporate encounter…",
    featured: false, permission: true,
  },
  {
    name: "Adam Pelfrey", photo: "/assets/testimonial-adam.png", photoPosition: "35% 20%", title: "District Youth Director", organization: "Appalachian AG",
    city: "", state: "", category: "", pullQuote: "",
    quote: "…a great worship leader… Passionate, talented, humble and loves to pour into younger worship leaders. He’s been a home run for us every single time.",
    featured: false, permission: true,
  },
  {
    name: "Jeff Leake", photo: "/assets/testimonial-jeff.jpeg", photoPosition: "center top", title: "Lead Pastor", organization: "Allison Park Church",
    city: "Pittsburgh", state: "PA", years: "1964–2026", category: "",
    pullQuote: "",
    excerpt: "A powerful capacity to lead people into a very real place where they can experience the flow of the person of the Holy Spirit.",
    quote: "David Rosenblum is one of my favorite worship leaders. Not only does he have an incredible voice, he also has a powerful capacity to lead people into a very real place where they can experience the flow of the person of the Holy Spirit. And in that place, David prophesies as he sings which transforms the soul.",
    featured: true, permission: true,
  },
  {
    name: "Joel Buckner", photo: "/assets/testimonial-joel.jpeg", photoPosition: "center 30%", title: "Communications Director", organization: "National Community Church",
    city: "Washington", state: "DC", category: "", pullQuote: "",
    quote: "I love how his style crosses all genres, which gives him the ability to connect with a range of people. I believe that he will be a great leader in this next generation of worship leaders.",
    featured: false, permission: true,
  },
  {
    name: "Steve Mason", photo: "/assets/testimonial-steve.jpeg", title: "Lead Pastor", organization: "Wilmar Assembly",
    city: "Wilmer", state: "MN", category: "", pullQuote: "",
    quote: "David Rosenblum is both a prophetic and passionate worship leader who understands how to lead his audience into the presence of God. He leads with excellence, but with a humble heart. I would highly recommend him for your next ministry event.",
    featured: false, permission: true,
  },
  {
    name: "Eran Holt", photo: "/assets/testimonial-eran.jpeg", title: "Evangelist & Youth Leader Coach", organization: "Lead The Generation",
    city: "Pittsburgh", state: "PA", category: "", pullQuote: "",
    quote: "Anointed, Passionate, Prophetic, A worship leader called to this generation… I have ministered to students for over 2 decades and I’m honored to say that David is one of best worship leaders I’ve worked with.",
    featured: false, permission: true,
  },
  {
    name: "Johnny Mendoza", photo: "/assets/testimonial-johnny.jpg", title: "District Youth Director", organization: "",
    city: "", state: "Georgia", category: "", pullQuote: "",
    quote: "David is not only extremely talented but also incredibly anointed. His ability to lead others (youth and adults alike) into God’s presence is both powerful and meaningful. His heart to serve the local church and empower its leaders is such a blessing to anyone who brings him in.",
    featured: false, permission: true,
  },
  {
    name: "Dr. Ron Crum", photo: "/assets/testimonial-ron.webp", photoPosition: "center 20%", title: "President", organization: "Deisensus Leadership",
    city: "Griffin", state: "GA", category: "",
    pullQuote: "",
    excerpt: "David’s gift before thousands, or in the secret place, takes us with him before His Father.",
    quote: "Worship. Many expressions, styles, and genres. David leads differently, authentic voice, Jesus centered, Presence led, and always all, everyone, entering. David’s gift before thousands, or in the secret place, takes us with him before His Father. Thankful David has stayed centered in Christ and God has honored him!",
    featured: true, permission: true,
  },
  {
    name: "Chase Morris", photo: "/assets/testimonial-chase.webp", photoPosition: "center 25%", title: "Youth Pastor & Worship Leader", organization: "Legacy Church",
    city: "Hot Springs", state: "AR", category: "",
    pullQuote: "",
    excerpt: "I am only in full-time ministry today because David poured into me for years, reminding me of the call of God he could see on my life.",
    quote: "It’s no exaggeration to say my life would not be what it is without David. As the worship pastor in the church I grew up in, he saw believed in me before I believed in myself. He helped me cultivate a love for God, music, and people all throughout my teenage and college years. I am only in full-time ministry today because David poured into me for years, reminding me of the call of God he could see on my life. If there’s one person’s influence I see in my ministry more than any other mentor, it’s David. And if there’s one mentor I strive to emulate in ministry, it’s David. As a middle schooler, he told me, “I’ll teach you everything I know if you’ll make me one promise. You’ve got to teach someone else one day.” Every time I sew into the life of another young person, it’s because David taught me how to.",
    featured: true, permission: true,
  },
  {
    name: "Knox Russell", photo: "/assets/testimonial-knox.webp", photoPosition: "45% 20%", title: "Student Worship Leader", organization: "",
    city: "Montgomery", state: "AL", category: "", pullQuote: "",
    quote: "Pastor David’s worship ministry has impacted my life in many ways. When I was 13 years old I was called to worship ministry. I do not believe it was a coincidence that Pastor David was leading the house that night. 2 years after that night I got to lead with Pastor David. He is not just a phenomenal worship leader, but his sensitivity to the Spirit is truly a gift. He is an amazing teacher of music and has helped me develop my craft in so many ways. He has not just taught me to be a better musician, but has also taught me to lead with humility, passion, and boldly.",
    featured: false, permission: true,
  },
  {
    name: "Ben Russell", photo: "/assets/testimonial-ben.jpeg", photoPosition: "center 20%", title: "District Youth Director", organization: "",
    city: "", state: "Alabama", category: "", pullQuote: "",
    quote: "David Rosenblum is a truly gifted worship leader who carries a unique anointing and a genuine heart for God and His people. He brings a powerful presence and a deep sensitivity to the Holy Spirit. David has a remarkable ability to lead people into worship and create an atmosphere where hearts are drawn closer to the Lord. Beyond his incredible gifting, David is a man of integrity, humility, and genuine love for people. We are honored to call him a friend, a trusted ministry partner, and truly consider him family.",
    featured: false, permission: true,
  },
  {
    name: "Zack Blevins", photo: "/assets/testimonial-zack.webp", photoPosition: "40% 20%", title: "Worship Leader", organization: "",
    city: "Knoxville", state: "TN", category: "", pullQuote: "",
    quote: "David has been one of the most influential figures in my life as long as I’ve known him. His musical talent is obvious, but his desire to invest in me as a worship musician has always been second to raising me up as a worship leader who leads people to an encounter with Jesus in the presence of the Holy Spirit.",
    featured: false, permission: true,
  },
  {
    name: "Brandon Harper", photo: "/assets/testimonial-brandon.jpeg", photoPosition: "center 25%", title: "Worship Pastor", organization: "River Ridge Church",
    city: "Hurricane", state: "WV", category: "",
    pullQuote: "Love people more than platforms.",
    excerpt: "I don’t think I would be half the leader I am today if not for David’s guidance in my life!",
    quote: "Being a worship leader, one of the first things people often ask is, “What made you want to be a worship leader?” or “Who is your biggest influence?” Without a doubt, David has been the biggest influence on my journey to become a worship leader. Initially, what drew me to David was not just his talent in singing but also his ability to lead a room. Much more than that, David mentored and discipled me off the platform. His love for people and the church is infectious. Every team he leads, he makes better not just because he is a talented musician, but because he takes the time to encourage, teach, and give honest feedback so that you can lead to your fullest potential. I can honestly say I don’t think I would be half the leader I am today if not for David’s guidance in my life! The biggest advice David ever gave me and lived out in front of me was “love people more than platforms” and “you can’t take people somewhere you haven’t been yourself; learn to love the secret place.” Lastly, because of his role in my life, I am now able to lead a team of students of my own and do for them what David did for me.",
    featured: true, permission: true,
  },
  {
    name: "Kelly Presson", photo: "/assets/testimonial-kelly.jpeg", title: "National Children’s Ministry Director", organization: "Assemblies of God",
    city: "Springfield", state: "MO", category: "", pullQuote: "",
    quote: "David’s ministry is not about performance. I love how he shows up to purely worship. Always brings an anointing with him. And takes every demographic in the room to an authentic place of worship. He doesn’t simply lead songs, he creates space for people to encounter God.",
    featured: false, permission: true,
  },
  {
    name: "Jon Catron", photo: "/assets/testimonial-jon.jpeg", photoPosition: "70% center", title: "Lead Pastor", organization: "Calvary Church",
    city: "Greensboro", state: "NC", category: "", pullQuote: "",
    quote: "David’s wisdom and anointing were very evident in the way he ministered during corporate worship experiences… I would highly recommend David for ministry at any event, large or small.",
    featured: false, permission: true,
  },
  {
    name: "Dr. Glen Wolf", photo: "/assets/testimonial-glen.jpeg", photoPosition: "center 20%", title: "Lead Pastor", organization: "Griffin First Assembly",
    city: "Griffin", state: "GA", category: "",
    pullQuote: "",
    excerpt: "What sets David apart is his genuine love for people and his passion for leading them into a deeper relationship with Jesus.",
    quote: "Pastor David Rosenblum is a strong, anointed leader whose character and calling are evident in every area of his life and ministry. I’ve had the privilege of knowing David over the last few years, and the longer I know him, the more I respect him and believe in what God is doing through him. While he is incredibly gifted musically and has an amazing voice, those talents are not what stand out most to me. What sets David apart is his genuine love for people and his passion for leading them into a deeper relationship with Jesus. His heart for ministry, humility, and commitment to helping others grow in their faith make him a leader I wholeheartedly trust and endorse.",
    featured: true, permission: true,
  },
  {
    name: "Kendall Alfaro", photo: "/assets/testimonial-kendall.jpeg", title: "National Speed The Light Director", organization: "Assemblies of God",
    city: "Springfield", state: "MO", category: "", pullQuote: "",
    quote: "David is a gift to the body of Christ. More than his musical ability, what stands out is his genuine love for Jesus and his passion for leading others into His presence. David has a unique way of creating space for people to encounter Jesus and become aware of the reality that the Kingdom of God is here and active among us. I wholeheartedly recommend his ministry to anyone who desires to know Jesus more deeply and experience authentic worship.",
    featured: false, permission: true,
  },
  {
    name: "John L’Hommedieu", photo: "/assets/testimonial-john.jpeg", title: "Next Gen Director", organization: "Church Eleven32",
    city: "Dallas", state: "TX", category: "", pullQuote: "",
    quote: "David Rosenblum carries a rare combination of genuine humility, undeniable gifting, and a deep sensitivity to the presence of God. He doesn’t simply lead songs, he leads people toward Jesus. Any church, conference, or ministry would be blessed to have David lead.",
    featured: false, permission: true,
  },
  {
    name: "Tony Cruz", photo: "/assets/testimonial-tony.jpeg", photoPosition: "55% 15%", title: "Evangelist & Lead Pastor", organization: "Freedom Life Church",
    city: "", state: "", category: "", pullQuote: "",
    quote: "Some people have talent and some have an anointing - David Rosenblum has both. To share the stage in ministry with a servant like him was a great experience.",
    featured: false, permission: true,
  },
];

// ── Podcasts & conversations ──────────────────────────────────
// Add appearances here — nothing is invented. Example:
// { name: "Podcast Name", episode: "Episode Title",
//   descriptor: "Optional short line", artwork: "/assets/podcast-1.jpg",
//   url: "https://open.spotify.com/episode/…" }
export const PODCASTS = [
  {
    name: "Hope For Today",
    episode: "Worship is the highway to the throne of God!",
    descriptor: "",
    artwork: "/assets/podcast-1.jpg",
    url: "https://open.spotify.com/episode/6miNVdF8ECNMQhke3gv5vt",
  },
  {
    name: "Legacy Church Podcast",
    episode: "Redeeming Lives in New Ways",
    descriptor: "",
    artwork: "/assets/podcast-2.jpg",
    url: "https://open.spotify.com/episode/0a1CT5mqUFVY1xEr7zwB1A",
  },
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Booking", href: "#invite" },
  { label: "Dates", href: "#dates" },
  { label: "Listen", href: "#listen" },
  { label: "Watch", href: "#videos" },
  { label: "Resources", href: "#resources" },
];
